import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.10_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aws-sdk+_383aa8d50542887f8a55cb0ed752a9a1/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}